//引入vue以及vueRouter
import Vue from 'vue'
import VueRouter from 'vue-router'

//第三方库需要use一下才能用
Vue.use(VueRouter)

//定义routes路由的集合，数组类型
const routes = [
  {
    path: '/landing',
    name: 'landing',
    component: () => import(/* webpackChunkName: "login" */ '@/views/PageLanding.vue'),
  },
  {
    path: '/landingA',
    name: 'landingA',
    component: () => import(/* webpackChunkName: "user" */ '@/views/PageLandingA.vue'),
  }
]

//实例化VueRouter并将routes添加进去
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

//抛出这个这个实例对象方便外部读取以及访问
export default router


// WEBPACK FOOTER //
// ./src/router/index.js